module.exports = __webpack_public_path__ + "static/media/jeno-6.jpeg";